<template>
  <div>
    <el-popover
      placement="bottom-end"
      width="130"
      class="theme-bar"
      v-model="visible">
      <el-row>
        <ThemePicker />
        <el-col class="border"></el-col>
        <template v-for="(item) in customThemes">          
          <el-col v-if="item.type===1" class="default-theme" style="margin-top:0" @click.native.stop="changeTheme(item.value)" :key="item.value">
            <i class="color-placeholder" :style="{'background-color':item.headerColor}"></i>
            <span :style="{'color':item.headerColor}">{{$t('theme.' + item.value)}}</span>
          </el-col>        
          <el-col class="border" v-if="item.value==='default'" :key="item.value+'1'"></el-col>          
          <!-- <el-col :span="12" v-if="item.type===2" :key="item.value">
            <el-col class="default-theme new-theme" @click.native.stop="changeTheme(item.value)">
              <i class="color-placeholder" :style="{'background-color':item.headerColor}"></i>
              <span :style="{'color':item.headerColor}">{{item.name}}</span>
            </el-col>
          </el-col>  -->          
          <el-col v-if="item.type===3" class="name-theme" :key="item.value" @click.native.stop="changeTheme(item.value)">            
            <svg-icon :color="item.headerColor" style="width:18px !important;height:18px !important" icon-class="theme-icon" />
            <span :style="{'color':item.headerColor}">{{$t('theme.' + item.value)}}</span>
          </el-col>                    
        </template>
      </el-row>
      
      <el-button :style="themeStyle" slot="reference" type="text">
        <svg-icon style="width:18px !important;height:18px !important" icon-class="theme-icon" />
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import ThemePicker from '@/components/ThemePicker'
const version = require('element-ui/package.json').version // element-ui version from node_modules
const ORIGINAL_THEME = '#409EFF' // default color
import { mapGetters } from 'vuex'
export default {
  name: 'ThemeBar',
  props: {
    themeStyle: {}
  },
  components: {
    ThemePicker
  },
  data() {
    return {
      visible: false,
      chalk: '',
      OriginalTheme: ORIGINAL_THEME
    }
  },
  computed: {
    ...mapGetters(['theme', 'customThemes', 'themeName'])
  },
  created() {
    var val = this.theme.main || '#409EFF'
    var oldVal = this.theme.main || '#409EFF'
    if (typeof val !== 'string') return
    const themeCluster = this.getThemeCluster(val.replace('#', ''))
    const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))
    const getHandler = (variable, id) => {
      return () => {
        const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
        const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

        let styleTag = document.getElementById(id)
        if (!styleTag) {
          styleTag = document.createElement('style')
          styleTag.setAttribute('id', id)
          document.head.appendChild(styleTag)
        }
        styleTag.innerText = newStyle
      }
    }
    const chalkHandler = getHandler('chalk', 'chalk-style')
    if (!this.chalk) {
      const url = '/static/theme-chalk/index.css' //`https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
      this.getCSSString(url, chalkHandler, 'chalk')
    } else {
      chalkHandler()
    }
    const styles = [].slice.call(document.querySelectorAll('style'))
      .filter(style => {
        const text = style.innerText
        return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
      })
    styles.forEach(style => {
      const { innerText } = style
      if (typeof innerText !== 'string') return
      style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
    })
  },
  watch: {
    themeName(val) {
      const oldVal = this.OriginalTheme
      if (typeof val !== 'string') return
      const themeCluster = this.getThemeCluster(this.customThemes[val].main.replace('#', ''))
      const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))
      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
          const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

          let styleTag = document.getElementById(id)
          if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.setAttribute('id', id)
            document.head.appendChild(styleTag)
          }
          styleTag.innerText = newStyle
        }
      }

      const chalkHandler = getHandler('chalk', 'chalk-style')

      if (!this.chalk) {
        const url =  '/static/theme-chalk/index.css' //`https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
        this.getCSSString(url, chalkHandler, 'chalk')
      } else {
        chalkHandler()
      }

      const styles = [].slice.call(document.querySelectorAll('style'))
        .filter(style => {
          const text = style.innerText
          return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
        })
      styles.forEach(style => {
        const { innerText } = style
        if (typeof innerText !== 'string') return
        style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
      })
    }
  },

  methods: {
    changeTheme(name) {
      this.$store.dispatch('ChangeTheme', name)
    },
    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style // only capture color overides
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    },

    getCSSString(url, callback, variable) {
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
          callback()
        }
      }
      xhr.open('GET', url)
      xhr.send()
    },

    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        if (tint === 0) { // when primary color is in its rgb space
          return [red, green, blue].join(',')
        } else {
          red += Math.round(tint * (255 - red))
          green += Math.round(tint * (255 - green))
          blue += Math.round(tint * (255 - blue))

          red = red.toString(16)
          green = green.toString(16)
          blue = blue.toString(16)

          return `#${red}${green}${blue}`
        }
      }

      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        red = Math.round((1 - shade) * red)
        green = Math.round((1 - shade) * green)
        blue = Math.round((1 - shade) * blue)

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)

        return `#${red}${green}${blue}`
      }

      const clusters = [theme]
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
      }
      clusters.push(shadeColor(theme, 0.1))
      return clusters
    }
  }
}
</script>
<style lang="scss">
  .el-popover{
    .name-theme{
      padding: 5px 0;
      cursor:pointer;
    }
    .svg-icon{
      margin-right: 5px;
    }
    .default-theme{
      line-height: 26px;
      margin: 2px 0;
      cursor:pointer;
    }
    .border{
      height: 1px;
      background: #ebeef5;
      margin: 5px 0;
    }
    .color-placeholder{
      display: inline-block;
      width: 18px;
      height: 18px;
      border-radius: 2px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
</style>
